import {  isLoaded, isLoading, manageSubTasks, subTasks } from "../actions";
import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";

export async function getSubTasks(dispatch, getUser, taskId, project_id) {
  dispatch(isLoading());
  try {
    var response = await API.post("get_tasks.php", {
      crop: getUser.corp,
      mainTaskId: taskId,
      action: "getsubtasks",
      "projectId": (project_id || getUser.projectId)
    }, {}, false);
    if (response.status === 'true') {
      dispatch(manageSubTasks(response.data))
      dispatch(subTasks(response.data))
    }
    else {
      dispatch(manageSubTasks([]));
      dispatch(subTasks([]));
    }
  } catch (error) {
    Alert('error', error.message);
    dispatch(isLoaded());
  }
  dispatch(isLoaded());
}